import { render, staticRenderFns } from "./dramaFestival.vue?vue&type=template&id=65b61ee1&scoped=true&"
import script from "./dramaFestival.vue?vue&type=script&lang=ts&"
export * from "./dramaFestival.vue?vue&type=script&lang=ts&"
import style0 from "./dramaFestival.vue?vue&type=style&index=0&id=65b61ee1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b61ee1",
  null
  
)

export default component.exports